import cn from '../utils/cn.ts';
import { CategoryColor, DataLayerData } from '../api/api.ts';
import NeumorphBox, { NeumorphType } from '../common/ui/NeumorphBox.tsx';
import Legend from './Common/Legend.tsx';
import { useMapContext, ViewType } from './Map.tsx';

export default function PanelLegend() {
  const { dataLayersForLegend, view } = useMapContext();
  return (
    <div
      className={cn(
        'absolute',
        'w-[200px]',
        'left-[30px]',
        'top-[30px]',
        'shadow-lg',
        'rounded-[12px]',
        'z-1000',
        'text-sm',
        'bg-gray-100',
        'transition-[width]',
        'transition-[height]',
        'p-[12px]',
        'pt-[12px]',
        'overflow-y-auto',
        'transition-all',
        view && view.type === ViewType.Story ? '-translate-y-[100vh]' : 'null'
      )}
      style={{
        maxWidth: 'calc(min( 600px, 100vw - (3 * 30px) - 270px))',
        minWidth: 'auto',
        maxHeight: 'calc(100vh - ( 2 * 30px ))',
      }}
    >
      <Legend dataLayers={dataLayersForLegend} />
    </div>
  );
}
